import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Row, Col, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../styles/LoginForm.css';
import { resetPasswordConfirmService } from '../../services/AuthService';

const ResetPasswordForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState('');

  useEffect(() => {
    // Extract token from query parameters
    const searchParams = new URLSearchParams(location.search);
    const resetToken = searchParams.get('token');
    if (resetToken) {
      setToken(resetToken);
    } else {
      navigate('/login'); // Redirect if no token found
    }
  }, [location, navigate]);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const { password } = values;
      const response = await resetPasswordConfirmService(token, password);

      const { success, message: responseMessage } = response;
      
          if (success) {
            message.success(responseMessage || 'Password reset successfully');
            navigate('/login'); // Redirect to login after successful request
          } else {
            message.error(responseMessage || 'Failed to  reset password. Please try again.');
          }
      
      //message.success('Password reset successfully!');
     // navigate('/login');
    } catch (error) {
      console.error('Reset error:', error);
      message.error('Password reset failed. Invalid token or request.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row justify="center" align="middle" className="login-form-container">
      <Col>
        <Form
          name="reset_password_form"
          className="login-form"
          onFinish={onFinish}
        >
          <div className="logo-container">
            <img src="/logo.png" alt="logo" className="logo-auth" />
          </div>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Please enter new password!' },
              { min: 8, message: 'Password must be at least 8 characters!' },
              { 
                pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, 
                message: 'Password must contain letters and numbers!' 
              }
            ]}
            hasFeedback
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="New Password"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="confirm"
            dependencies={['password']}
            hasFeedback
            rules={[
              { required: true, message: 'Please confirm your password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match!'));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="Confirm Password"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              className="login-form-button" 
              size="large" 
              loading={loading}
              block
            >
              Reset Password
            </Button>
          </Form.Item>

          <Row justify="center">
            <p>Remember your password? </p>
            <p 
              style={{ color: '#1890ff', cursor: 'pointer', marginLeft: '5px' }}
              onClick={() => navigate('/login')}
            >
              Log In
            </p>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default ResetPasswordForm;